import "./Consulting.css";
import Image1 from "../../Images/Image1.png";
import Image2 from "../../Images/Image2.png";
import Image3 from "../../Images/Image3.png";
import Image4 from "../../Images/Image4.png";
import Image5 from "../../Images/Image5.png";
import Award1 from "../../Images/award.png";
import Award2 from "../../Images/award2.png";
import ConsultingBackground from "../../Images/ConsultingBackground.png";
import oci from "../../Images/oci.png";
import kaha from "../../Images/kaha.png";
import theskinstore from "../../Images/theskinstore.png";
import hosachiguru from "../../Images/hosachiguru.png";
import hydro_products from "../../Images/hydro_products.png";
import mscr from "../../Images/mscr.png";
import offineeds from "../../Images/offineeds.png";
import saroj from "../../Images/saroj.png";
import parinat from "../../Images/parinat.png";
import ContactUs from "../ContactUs";

const Consulting = () => {
  return (
    <>
      {/* Hero Section */}
      <section
        className="hero-section-consulting"
        style={{ backgroundImage: `url(${ConsultingBackground})` }}
      >
        <div className="hero-content">
          <h1 className="hero-title">For Consulting Services</h1>
        </div>
      </section>

      {/* Services Introduction */}
      <section className="services-intro">
        <h2>Let us help you/ your organisation</h2>

        {/* Image 1 */}
        <div className="service-image-container">
          <img src={Image1} alt="Let us help you" className="service-image" />
        </div>

        <p>
          At HR Labs we have come long a way, and we provide a wide range of
          services.
        </p>
        <h3 className="expertise-title">What do we Expertise in?</h3>

        {/* Image 2 */}
        <div className="service-image-container1">
          <img src={Image2} alt="Our Expertise" className="service-image" />
        </div>
      </section>

      {/* Awards Section */}
      <section className="awards-section">
        <h2>Awards</h2>

        {/* Auto-scrolling Carousel */}
        <div className="awards-carousel-container">
          <div className="awards-carousel">
            {/* Award 1 */}
            <div className="award-carousel-item">
              <div className="award-image-wrapper">
                <img
                  src={Award1}
                  alt="Award 1"
                  className="award-carousel-image"
                />
              </div>
              <p className="award-caption">
                Centre for Leadership Development & Human Excellence
              </p>
            </div>

            {/* Award 2 */}
            <div className="award-carousel-item">
              <div className="award-image-wrapper">
                <img
                  src={Award2}
                  alt="Award 2"
                  className="award-carousel-image"
                />
              </div>
              <p className="award-caption">TEPL, India, Karnataka, Bangalore</p>
            </div>
          </div>
        </div>
      </section>

      {/* Brands Section */}
      <section className="brands-section">
        <h2>Brands he has Consulted and worked with (Partial List)</h2>

        {/* Auto-scrolling Brand Carousel */}
        <div className="brands-carousel-container">
          <div className="brands-carousel">
            <div className="brand-carousel-item">
              <img src={oci} alt="OCI" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img src={kaha} alt="Kaha" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img
                src={theskinstore}
                alt="The Skin Store"
                className="brand-logo"
              />
            </div>
            <div className="brand-carousel-item">
              <img src={hosachiguru} alt="Hosachiguru" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img
                src={hydro_products}
                alt="Hydro Products"
                className="brand-logo"
              />
            </div>
            <div className="brand-carousel-item">
              <img src={mscr} alt="MSCR" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img src={offineeds} alt="Offineeds" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img src={saroj} alt="Saroj" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img src={parinat} alt="Parinat" className="brand-logo" />
            </div>
            {/* Duplicate for seamless loop */}
            <div className="brand-carousel-item">
              <img src={oci} alt="OCI" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img src={kaha} alt="Kaha" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img
                src={theskinstore}
                alt="The Skin Store"
                className="brand-logo"
              />
            </div>
            <div className="brand-carousel-item">
              <img src={hosachiguru} alt="Hosachiguru" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img
                src={hydro_products}
                alt="Hydro Products"
                className="brand-logo"
              />
            </div>
            <div className="brand-carousel-item">
              <img src={mscr} alt="MSCR" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img src={offineeds} alt="Offineeds" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img src={saroj} alt="Saroj" className="brand-logo" />
            </div>
            <div className="brand-carousel-item">
              <img src={parinat} alt="Parinat" className="brand-logo" />
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="why-choose-section">
        <h2>Why Clients Choose HRLabs over Competitors?</h2>

        {/* Image 5 */}
        <div className="why-choose-image-container">
          <img src={Image3} alt="Why Choose Us" className="why-choose-image" />
        </div>

        <div className="why-choose-content">
          <p>
            Exceptional service quality, proven track record, and personalized
            solutions tailored to your business needs.
          </p>
        </div>
      </section>

      {/* VMVC Section */}
      <section className="vmvc-section">
        <h2>HR Labs - VMVC (Vision, Missions, Values, Culture)</h2>

        <div className="vmvc-card">
          <h3>Vision:</h3>

          {/* Image 6 */}
          <div className="vmvc-image-container">
            <img src={Image4} alt="Our Vision" className="vmvc-image" />
          </div>

          <p>
            Help 1,00,000 Start-ups, MSME's Transform their Business supporting
            Make in India Movement.
          </p>
        </div>

        <div className="vmvc-card">
          <h3>Values:</h3>
          <ul>
            <li>
              <strong>Customers:</strong> Are, will be & to be attended with
              Utmost Priority.
            </li>
            <li>
              <strong>Integrity & Honesty:</strong> Being Truthful, upright &
              reliable.
            </li>
            <li>
              <strong>Quality & Excellence:</strong> Bring-in superior, merit &
              worth of experience in whatever we do.
            </li>
            <li>
              <strong>Innovation:</strong> Believe & work on Continuous
              Improvements & Advancements.
            </li>
            <li>
              <strong>Creativity:</strong> Encourage imagination & inspire
              people to think there is always a better way of doing things.
            </li>
            <li>
              <strong>Progress:</strong> We continually assess our
              effectiveness.
            </li>
            <li>
              <strong>Mother Earth:</strong> Lets respect and care about the
              place we live.
            </li>
          </ul>
        </div>

        <div className="vmvc-card">
          <h3>Culture:</h3>

          {/* Image 7 */}
          <div className="vmvc-image-container">
            <img src={Image5} alt="Our Culture" className="vmvc-image" />
          </div>

          <blockquote>
            "We do whatever can be done to help companies succeed. We believe in
            taking time to pause and see how they are progressing and focus on
            helping the team & work towards cultivating an environment for
            growth".
          </blockquote>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2>Let me help you transform your business</h2>
        <ContactUs />
      </section>
    </>
  );
};

export default Consulting;
